import styled from "styled-components";
import Link from "gatsby-link";

import { P } from '../elements';

import { fromThemeProps } from "../../../helpers/utilities";
import { flex } from "../../../helpers/mixins";
import media from "../../../helpers/media";

const StyledNav = styled.div`
    ${flex({ dir: "column", jc: "space-between", ai: "center" })}
`

StyledNav.LinkContainer = styled.div`
    ${flex({ dir: "column", jc: "center", ai: "flex-start" })}
`

StyledNav.Link = styled(P)`
    margin-bottom: 1.5rem;
    border-bottom: ${(props) => {
    if (props.isSelected) return "6px solid #F14E26";
  }};

    color: ${fromThemeProps("black")};
    font-weight: bold;
    line-height: 0.4;
    text-decoration: none;
    text-transform: uppercase; 

    &:hover {
      font-weight: 500;
      cursor: pointer;
    }  
`

StyledNav.NestedLink = styled(Link)`
  display: ${(props) => {
    if (props.showNested) {
      return "flex"
    }
    return "none"
  }};
  margin-left: 1.5rem;
  margin-bottom: 1.5rem;
  border-bottom: ${(props) => {
    if (props.isSelected) return "6px solid #F14E26";
  }};

  color: ${fromThemeProps("black")};
  font-family: ${fromThemeProps("pFont")};
  font-size: ${fromThemeProps("pFontSizeMobile")};
  font-weight: bold;
  line-height: 0.4;

  ${media.xs`
    font-size: ${fromThemeProps("pFontSizeDesktop")};
  `}

  &:hover {
      font-weight: 500;
    } 
`

StyledNav.Arrow = styled.img`
    width: 15px;
    transform: ${(props) => {
    if (props.showNested) {
      return "rotate(0)"
    }
    return "rotate(180deg)"
  }};
`

StyledNav.Divider = styled.div`
    margin: 0.5em auto 1em;
    width: 30px;
    
    border-bottom: 6px solid ${fromThemeProps("orange")};
`

export default StyledNav;


// WEBPACK FOOTER //
// ./src/styles/styledComponents/blocks/styledNav.js